import type { Optional } from '@shared/utils';

import type { GroupOption } from '../types';

export const ALL_GROUP_OPTION: GroupOption = {
  label: 'All Group',
  value: undefined,
};

export const UNASSIGNED_OPTION: GroupOption = {
  label: 'ไม่ระบุกลุ่ม',
  value: 'unassigned',
};

export function filterAndInsertOption(
  newOptions: GroupOption[],
  mainOptions: GroupOption[],
  currValue: string,
  defaultOption?: GroupOption,
) {
  const filteredNewOptions = [];
  for (const element of newOptions) {
    const value = currValue.toLowerCase();
    const isIncluded =
      currValue === '' ||
      value === defaultOption?.label.toLowerCase() ||
      element.label.toLowerCase().includes(value);
    if (isIncluded) {
      filteredNewOptions.push(element);
    }
  }
  return filteredNewOptions.concat(mainOptions);
}

export function convertToGroupTagId(groupId: Optional<string>) {
  switch (groupId) {
    case ALL_GROUP_OPTION.value:
    case '': // for handle all-group option from nuq return, it'll return empty string when it's undefined
      return undefined;
    case UNASSIGNED_OPTION.value:
      return null;
    default:
      return groupId;
  }
}
